import glsl from "refractor/glsl";
export default glsl;